import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import EuroIcon from "@material-ui/icons/EuroSymbol";
import Paper from "@material-ui/core/Paper";

import {
  Event as ScheduleIcon,
  PictureAsPdf as PdfIcon,
  Mail as MailIcon,
  PhoneAndroid as PhoneIcon,
  Report,
} from "@material-ui/icons";
import "./style.css";

function descendingComparator(a, b, orderBy) {
  if (typeof b[orderBy] == "number") {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
  } else {
    if (b[orderBy].toLowerCase() < a[orderBy].toLowerCase()) {
      return -1;
    }
    if (b[orderBy].toLowerCase() > a[orderBy].toLowerCase()) {
      return 1;
    }
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = props.headCells;

  return (
    <TableHead>
      <TableRow>
        <TableCell></TableCell>

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            //align={headCell.numeric ? 'right' : 'left'}
            align={"left"}
            padding={false ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{
              fontWeight: "bold",
              width: headCell.id == "__" ? "20px" : "auto",
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    ></Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

//create your forceUpdate hook
function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}

export default function SearchTable(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState(props.headCells[0].id);
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [headCells, setHeadCells] = React.useState([]);

  var rows = props.rows;

  useEffect(() => {
    var cells = [];
    cells = props.headCells;
    cells.push({});
    setHeadCells(props.hea);
  }, []);

  if (searchText != "") {
    rows = [];
    props.rows.forEach((r) => {
      var found = false;
      var lowerSearch = searchText.toLowerCase();

      props.searchCols.forEach((element) => {
        if (r[element] && r[element].toLowerCase().indexOf(lowerSearch) != -1)
          found = true;
      });

      if (found == true) rows.push(r);
    });
  }

  const forceUpdate = useForceUpdate();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.eventName);
      //   setSelected(newSelecteds);
      return;
    }
    //   setSelected([]);
  };

  const handleChange = (e) => {
    console.log(e.target.value);
    setSearchText(e.target.value);
    forceUpdate();
  };

  const resetSearch = () => {
    if (searchRef.current != null) {
      searchRef.current.value = "";
      setSearchText("");
    }
    forceUpdate();
  };

  const handleClick = (id, name) => {
    if (props.onEventClick) props.onEventClick(id, name);

    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    //   setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  var searchRef = React.createRef();

  return (
    <div className={classes.root}>
      <div style={{ marginBottom: 10, display: "inline-flex" }}>
        Cerca:
        <input
          ref={searchRef}
          value={searchText}
          style={{ marginLeft: 10 }}
          type="text"
          onChange={(e) => {
            handleChange(e);
          }}
        ></input>
        <div
          style={{ marginLeft: 10, cursor: "pointer" }}
          onClick={resetSearch}
        >
          X
        </div>
      </div>

      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              headCells={props.headCells}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.eventName);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  const bgColor = index % 2 === 0 ? "#ffffff" : "#f5f5f5";

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={Math.random()}
                      selected={isItemSelected}
                      style={{ backgroundColor: bgColor }}
                    >
                      <TableCell padding="checkbox">
                        {/* <CheckBox elementId={row.id} onElementCheck={props.onElementCheck}/> */}
                      </TableCell>

                      {props.headCells.map((elem) => {
                        if (elem.id === "_") {
                          if (props.type === "billing") {
                            return (
                              <TableCell
                                key={Math.random()}
                                onClick={(event) =>
                                  handleClick(row.id, row["tipo"])
                                }
                                align="left"
                              ></TableCell>
                            );
                          }

                          if (row["tipo"] === "Corso") {
                            return (
                              <TableCell
                                key={Math.random()}
                                align="right"
                                className="iconsColumn"
                                style={{ display: "flex", marginTop: 10 }}
                              >
                                <ScheduleIcon
                                  className="icon"
                                  style={{
                                    marginRight: 20,
                                    height: "20px",
                                    width: "20px",
                                  }}
                                  onClick={() => {
                                    props.onCalendarClick(row.id, row["tipo"]);
                                  }}
                                />
                                <PdfIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() => {
                                    props.onPdfClicked &&
                                      props.onPdfClicked(row.id, row["tipo"]);
                                  }}
                                />
                                <MailIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() =>
                                    props.onSendMail &&
                                    props.onSendMail(row.id, row["tipo"])
                                  }
                                />
                                <PhoneIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() =>
                                    props.onSendNotification &&
                                    props.onSendNotification(
                                      row.id,
                                      row["tipo"]
                                    )
                                  }
                                />
                              </TableCell>
                            );
                          } else if (row["tipo"] === "Aula") {
                            return (
                              <TableCell
                                key={Math.random()}
                                align="right"
                                className="iconsColumn"
                                style={{ display: "flex", marginTop: 10 }}
                              >
                                <ScheduleIcon
                                  className="icon"
                                  style={{
                                    marginRight: 20,
                                    height: "20px",
                                    width: "20px",
                                  }}
                                  onClick={() => {
                                    props.onCalendarClick(row.id, row["tipo"]);
                                  }}
                                />
                                <PdfIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() => {
                                    props.onPdfClicked &&
                                      props.onPdfClicked(row.id, row["tipo"]);
                                  }}
                                />
                              </TableCell>
                            );
                          } else if (row["tipo"] === "Insegnante") {
                            return (
                              <TableCell
                                key={Math.random()}
                                align="right"
                                className="iconsColumn"
                                style={{ display: "flex" }}
                              >
                                <EuroIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() =>
                                    props.onInvoicesPressed(row.id, row["tipo"])
                                  }
                                />
                                <PdfIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() => {
                                    props.onPdfClicked &&
                                      props.onPdfClicked(row.id, row["tipo"]);
                                  }}
                                />
                                <MailIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() =>
                                    props.onSendMail &&
                                    props.onSendMail(row.id, row["tipo"])
                                  }
                                />
                                <PhoneIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() =>
                                    props.onSendNotification &&
                                    props.onSendNotification(
                                      row.id,
                                      row["tipo"]
                                    )
                                  }
                                />
                              </TableCell>
                            );
                          } else if (row["tipo"] === "Studente") {
                            return (
                              <TableCell
                                key={Math.random()}
                                align="right"
                                className="iconsColumn"
                                style={{ display: "flex" }}
                              >
                                <Report
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() =>
                                    props.onAssenze(row.id, row["tipo"])
                                  }
                                />
                                <PdfIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() => {
                                    props.onPdfClicked &&
                                      props.onPdfClicked(row.id, row["tipo"]);
                                  }}
                                />
                                <MailIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() =>
                                    props.onSendMail &&
                                    props.onSendMail(row.id, row["tipo"])
                                  }
                                />
                                <PhoneIcon
                                  className="icon"
                                  style={{ height: "20px", width: "20px" }}
                                  onClick={() =>
                                    props.onSendNotification &&
                                    props.onSendNotification(
                                      row.id,
                                      row["tipo"]
                                    )
                                  }
                                />
                              </TableCell>
                            );
                          }
                        } else
                          return (
                            <TableCell
                              key={Math.random()}
                              onClick={(event) =>
                                handleClick(row.id, row["tipo"])
                              }
                              align="left"
                            >
                              {row[elem.id]}
                            </TableCell>
                          );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25]}
          component="div"
          count={rows.length}
          rowsPerPage={25}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

/* return(
    <TableCell align="right" className="iconsColumn" style={{display: 'flex'}}>
    {(props.calendar != undefined && props.calendar == true) && <ScheduleIcon className="icon" style={{marginRight: 20, height: '20px', width: '20px'}} onClick={() => {
        props.onCalendarClick(row.id);
//                          window.location.href= '#/app/schedule';
    } }/> }
    {props.invoices && <EuroIcon className="icon" style={{height: '20px', width: '20px'}} onClick={() => props.onInvoicesPressed(row.id)}/> }
    {(props.pdf != undefined && props.pdf == true) && <PdfIcon className="icon" style={{height: '20px', width: '20px'}} onClick={() => {
        props.onPdfClicked && props.onPdfClicked(row.id);
    }}/>}
    {(props.mail != undefined && props.mail == true) &&  <MailIcon className="icon" style={{height: '20px', width: '20px'}} onClick={() => props.onSendMail && props.onSendMail(row.id)}/>}
    {(props.phone != undefined && props.phone == true) &&  <PhoneIcon className="icon" style={{height: '20px', width: '20px'}} onClick={() => props.onSendNotification && props.onSendNotification(row.id)}/>}
    {props.onDelete && <DeleteIcon className="icon" style={{height: '20px', width: '20px'}} onClick={() => props.onDelete(row.id)}/> }
    {props.assenze && <Report className="icon" style={{height: '20px', width: '20px'}} onClick={() => props.onAssenze(row.id)} /> }
    </TableCell>
); */
